import * as actionTypes from '../actions/actionTypes';
import { EmperorTentState } from "./stateType";
import { GovernyInfo } from "../../lib/types";

type InitStateAction = {
  newState: EmperorTentState;
}

type SetChangedAction = {
  changed: boolean;
}

type UpdateMemberAction = {
  memberId: number;
  update: Partial<GovernyInfo>;
}

const initialState: EmperorTentState = {
  members: null,
  changed: false
}

const initState = (state: EmperorTentState, { newState }: InitStateAction) => ({
  ...(newState || { members: null })
});

const setChanged = (state: EmperorTentState, { changed }: SetChangedAction) => ({
  ...state,
  changed
});

const updateMember = (state: EmperorTentState, { memberId, update }: UpdateMemberAction) => {
  const members = state.members?.slice();
  const memberIndex = members?.findIndex((g => g.id === memberId));
  if (!members || memberIndex === undefined || memberIndex === -1) {
    return state;
  }
  const member = {
    ...members[memberIndex],
    ...update
  }
  members.splice(memberIndex, 1, member);

  return {
    ...state,
    members,
    changed: true
  }
}

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.EMP_TENT_INIT_STATE: return initState(state, action);
    case actionTypes.EMP_TENT_SET_CHANGED: return setChanged(state, action);
    case actionTypes.EMP_TENT_UPDATE_MEMBER: return updateMember(state, action);
    default: return state;
  }
};

export default reducer;
